import { Box, FlexBox, Text } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';

/** Represents a component for whenever there are no sms phone numbers. */
export const SmsEmpty = (): JSX.Element => {
  return (
    <FlexBox
      flexDirection="column"
      alignItems="center"
      gap={sizes.spacer[200]}
      margin="150px 0 0 0"
    >
      <Text.Heading>Give your customers text message support</Text.Heading>
      <Box width="350px">
        <Text.Paragraph align="center">
          Interested? Contact our Customer Success team for more details.
        </Text.Paragraph>
      </Box>
    </FlexBox>
  );
};
